import { cn } from "tools/ui";
import { TimeIcon } from "components/Icons";

function fmtTime(value) {
  if (!value) return "";
  const str = String(value);
  return str.length > 5 ? str.slice(0, -3) : str;
}

function ShiftPopover({ pos, shifts, onMouseEnter, onMouseLeave }) {
  if (!pos || !shifts?.length) return null;

  return (
    <div
      className="fixed z-50"
      style={{ left: pos.left, top: pos.top }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        className={cn(
          "absolute top-3.5 w-2.5 h-2.5 rotate-45 bg-white",
          pos.side === "left" ? "-right-1" : "-left-1",
        )}
      />
      <div className="w-max overflow-hidden rounded-xl border border-neutral-100 bg-white shadow-xl shadow-amber-900/10">
        <div className="flex flex-col gap-2.5 p-2.5">
          {shifts.map((shift, i) => (
            <div key={i} className="flex flex-col gap-1.5">
              {shift.name && (
                <span className="text-[11px] font-bold uppercase tracking-wide text-neutral-400">
                  {shift.name}
                </span>
              )}
              {shift.start && shift.end && (
                <span className="flex items-center gap-1.5 text-xs text-neutral-900">
                  <TimeIcon className="size-3.5 fill-current text-neutral-900" />
                  <span className="font-medium">
                    {fmtTime(shift.start)} - {fmtTime(shift.end)}
                  </span>
                  {shift.total_time != null && (
                    <span className="ml-auto rounded-full bg-blue-50 px-1.5 py-0.5 text-[10px] font-semibold text-neutral-700">
                      {shift.total_time}h
                    </span>
                  )}
                </span>
              )}
              {shift.start_rest && shift.end_rest && (
                <p className="flex items-center gap-1.5 text-[11px] text-neutral-500">
                  <span className="size-1.5 ml-1 rounded-full bg-blue-300" />
                  Descanso: {fmtTime(shift.start_rest)} - {fmtTime(shift.end_rest)}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ShiftPopover;